import { Drawer } from '@material-ui/core'
import React, { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { CloseButton } from '../../Template/Modal'
import DateRangePickerWrapper from './DatePickerWrapper'
import { DatePickerDrawerText } from './styled'

interface IDatePickerDrawerProps {
  open?: boolean
  onClose?: () => void
  header?: ReactNode
}

const DatePickerDrawer: FC<Omit<IDatePickerDrawerProps, 'anchorEl'>> = ({
                                                                          open,
                                                                          onClose,
                                                                          children,
                                                                          header,
                                                                        }) => {
  const [t] = useTranslation()

  return (
    <Drawer anchor="bottom" open={open} onClose={onClose}>
      <DateRangePickerWrapper>
        <Flex column={true} full={true}>
          <div>
            <Flex row={true} justifyBetween={true}>
              <DatePickerDrawerText>
                {header || t('z677_term')}
              </DatePickerDrawerText>
              <CloseButton
                onClose={onClose}
                style={{ margin: '-10px -10px 0 0' }}
              />
            </Flex>
          </div>
          {open && children}
        </Flex>
      </DateRangePickerWrapper>
    </Drawer>
  )
}

export default DatePickerDrawer
